import { render, staticRenderFns } from "./FooterBottomComponent.vue?vue&type=template&id=65b7b8f6&lang=pug&"
import script from "./FooterBottomComponent.vue?vue&type=script&lang=js&"
export * from "./FooterBottomComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports